



















































export default {
  name: "InputField2",
  props: {
    value: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    ref: {
      type: String,
      default: null
    },
    style: {
      type: Array,
      required: false,
      default: null
    }
    // val: {
    //   type: Object,
    //   required: true
    // }
  },
  data() {
    return {
      showDatePicker: false
    };
  },
  methods: {
    focus: function() {
      this.$refs.input.focus();
    }
  },
  computed: {
    // inputValue: {
    //   get() {
    //     return this.value.value;
    //   },
    //   set(val) {
    //     this.$emit("input", val);
    //   }
    // }
  }
};
